<app-attention-modal [type]="confirmType" [title]="title" [messageTemplate]="message" [buttonsTemplate]="buttons"></app-attention-modal>

<ng-template #message>
  <div [innerHTML]="text"></div>
</ng-template>

<ng-template #buttons>
  <button rktButton btnType="tertiary" title="Cancel" (click)="activeModal.close()">Cancel</button>
  <button rktButton [class.error-btn]="confirmType === 'error'" [title]="confirmBtnText || 'Confirm'" (click)="activeModal.close(true)">
    {{ confirmBtnText || 'Confirm' }}
  </button>
</ng-template>
